export function slugify(value: string): string {
  return value
    .toLowerCase()
    .replace(/a\/c/g, 'ac')
    .replace(/&/g, 'and')
    .replace(/\//g, '-')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/[\s-]+/g, '-')
    .replace(/^-+|-+$/g, '')
}
